import { isAfter, isBefore, isWithinInterval } from 'date-fns'

import {
  QueueStatsDateValueFilter,
  RangeDirection,
  TimeRange,
  TimeRangeResult,
  TimeScale,
} from 'types'

import {
  normaliseDailyDate,
  normaliseWeeklyFromDate,
  normaliseWeeklyToDate,
} from './calculateInitialTimeRangePages'
import { calculateNextTimeRange } from './calculateNextTimeRange'

export const calculateInitialTimeRangeForFilteredTimeframe = ({
  ranges,
  currentTimeRangeIndex,
  timeframeFilters,
  timeScale,
  supportsFuture,
}: {
  ranges: TimeRange[]
  currentTimeRangeIndex: number
  timeframeFilters: TimeRange<QueueStatsDateValueFilter | undefined>
  timeScale: TimeScale
  supportsFuture?: boolean
}): TimeRangeResult | null => {
  if (!timeframeFilters.from || !timeframeFilters.to || !ranges[currentTimeRangeIndex]) {
    return null
  }

  let workingRanges = [...ranges]
  let workingIndex = currentTimeRangeIndex

  let normalisedFilterFrom = timeframeFilters.from.value
  let normalisedFilterTo = timeframeFilters.to.value

  if (timeScale === TimeScale.Daily) {
    normalisedFilterFrom = normaliseDailyDate(timeframeFilters.from.value)
    normalisedFilterTo = normaliseDailyDate(timeframeFilters.to.value)
  }

  if (timeScale === TimeScale.Weekly) {
    normalisedFilterFrom = normaliseWeeklyFromDate(timeframeFilters.from.value)
    normalisedFilterTo = normaliseWeeklyToDate(timeframeFilters.to.value)
  }

  while (
    !isWithinInterval(normalisedFilterFrom, {
      start: workingRanges[workingIndex].from,
      end: workingRanges[workingIndex].to,
    })
  ) {
    let direction: RangeDirection

    if (isAfter(workingRanges[workingIndex].from, normalisedFilterFrom)) {
      direction = RangeDirection.Previous
    } else if (isBefore(workingRanges[workingIndex].to, normalisedFilterTo)) {
      direction = RangeDirection.Next
    } else {
      break
    }

    const nextRangeData = calculateNextTimeRange({
      direction,
      ranges: workingRanges,
      currentTimeRangeIndex: workingIndex,
      timeScale,
      supportsFuture,
    })

    if (nextRangeData) {
      if (typeof nextRangeData.rangeIndex !== 'undefined') {
        workingIndex = nextRangeData.rangeIndex
      }
      if (typeof nextRangeData.ranges !== 'undefined') {
        workingRanges = nextRangeData.ranges
      }
    }
  }

  return {
    ranges: workingRanges,
    rangeIndex: workingIndex,
  }
}
